import { useState } from "react";
import { db } from "../firebase";
import { doc, deleteDoc, collection, getDocs } from "firebase/firestore";
import { useNavigate, useLocation } from "react-router-dom";

function DeleteTournament() {
  const navigate = useNavigate();
  const location = useLocation();

  const { id, data, collectionName } = location.state || {};

  const [loading, setLoading] = useState(false);

  const deleteTournament = async () => {
    if (!window.confirm("Are you sure?")) return;

    setLoading(true);

    try {
      // 🔥 participants delete
      const partSnap = await getDocs(
        collection(db, `${collectionName}/${id}/participants`)
      );

      for (let d of partSnap.docs) {
        await deleteDoc(d.ref);
      }

      // 🔥 winners delete
      const winSnap = await getDocs(
        collection(db, `${collectionName}/${id}/winners`)
      );

      for (let d of winSnap.docs) {
        await deleteDoc(d.ref);
      }

      // 🔥 main delete
      await deleteDoc(doc(db, collectionName, id));

      alert("Deleted ✅");
      navigate(-1);

    } catch (e) {
      alert("Error: " + e.message);
    }

    setLoading(false);
  };

  return (
    <div style={container}>
      <div style={card}>
        <h1 style={title}>🗑 Delete Tournament</h1>

        {/* 🔥 INFO */}
        <p><b>Title:</b> {data?.title}</p>
        <p><b>Map:</b> {data?.map}</p>
        <p><b>Entry:</b> ₹{data?.entryFee}</p>
        <p><b>Prize:</b> ₹{data?.prizePool}</p>

        <button style={deleteBtn} onClick={deleteTournament}>
          {loading ? "Deleting..." : "Confirm Delete"}
        </button>

        <button style={cancelBtn} onClick={() => navigate(-1)}>
          Cancel
        </button>
      </div>
    </div>
  );
}

/* 🔥 STYLES */

const container = {
  minHeight: "100vh",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  background: "linear-gradient(135deg, #0F1221, #0A0D1A)",
};

const card = {
  background: "#1E2235",
  padding: 25,
  borderRadius: 12,
  width: 350,
  display: "flex",
  flexDirection: "column",
  gap: 10,
};

const title = {
  color: "#fff",
  textAlign: "center",
};

const deleteBtn = {
  marginTop: 10,
  padding: 12,
  borderRadius: 10,
  border: "none",
  background: "red",
  color: "#fff",
  cursor: "pointer",
};

const cancelBtn = {
  padding: 10,
  borderRadius: 10,
  border: "none",
  background: "#374151",
  color: "#fff",
  cursor: "pointer",
};

export default DeleteTournament;